import { useState } from "react";
import { useExpertApplications } from "@/hooks/useExpertApplications";
import { usePublishedExperts } from "@/hooks/usePublishedExperts";

export function useExpertApplicationsData() {
  const { applications, loading, fetchApplications } = useExpertApplications();
  const { publishedExperts, loading: publishedLoading, fetchPublishedExperts } = usePublishedExperts();
  const [refreshing, setRefreshing] = useState(false);

  const handleManualRefresh = async () => {
    // console.log("🔄 Manual refresh triggered");
    setRefreshing(true);
    try {
      await fetchApplications(true);
      await fetchPublishedExperts();
      // console.log("✅ Manual refresh completed");
    } catch (error) {
      // console.error("❌ Error during manual refresh:", error);
    } finally {
      setRefreshing(false);
    }
  };

  const handleDataRefresh = async () => {
    // console.log("🔄 Refreshing data after status update...");
    console.log("🔄 Refreshing data after status update...");
    setRefreshing(true);
    
    try {
      console.log("🔄 Force refreshing applications...");
      await fetchApplications(true);
      
      console.log("🔄 Force refreshing published experts...");
      await fetchPublishedExperts();
      
      console.log("✅ Data refresh completed successfully");
    } catch (error) {
      console.error("❌ Error during data refresh:", error);
    } finally {
      setRefreshing(false);
    }
  };

  const isLoading = loading || publishedLoading || refreshing;

  return {
    applications,
    publishedExperts,
    isLoading,
    handleManualRefresh,
    handleDataRefresh,
    fetchPublishedExperts
  };
}
